<template>
  <div class="alert">
    
  </div>
</template>

<script>
export default {
  name: "alert",
  props: ["alt"],
  data() {
    return {};
  },
  methods: {
    //隐藏中奖、活动弹窗
    hideModel() {
      this.$emit("hideModel", 1);
    },

    //Jegotrip.openRnPage(JSON.stringify({ funType: 'couponsview', funParams: {} }));
    //跳转app优惠券列表20190715
    apply() {
      console.log("---打开优惠券列表---");
      try {
        Jegotrip.openRnPage(
          JSON.stringify({ funType: "couponsview", funParams: {} })
        );
      } catch (e) {
        this.$Toast("网络不给力，请稍后再试");
      }
    }
  },
  created() {}
};
</script>

<!-- <style scoped src="../../static/css/index.css"></style> -->
<!-- Add "scoped" attribute to limit CSS to this component only -->


